import _ from 'lodash';

export const composeBarChartData = (data, fields, labelField, labelSuffix) =>
  fields.map(field =>
    data.map(row =>
      ({
        x: row[labelField].toString(),
        y: row[field],
        label: labelSuffix ? `${row[field]} ${labelSuffix}` : row[field],
      }
      )));

export const formatLabels = (data, label) => _.map(data, (row) => {
  const check = row[label];
  return `${check}`;
});

const receptacleCount = {
  title: 'Receptacle Count',
  type: 'stackedColumn',
  fields: [{
    name: 'PREDES with RESDES',
    color: '#7dbd7b',
  }, {
    name: 'PREDES without RESDES',
    color: '#ef696e',
  }],
  yTickFormat: amount => amount,
  xTickValues: data => formatLabels(data, 'hour'),
  composeChartData: data => composeBarChartData(
    data,
    ['predesWithResdesCount', 'predesWithoutResdesCount'],
    'hour',
  ),
};

const receptacleWeight = {
  title: 'Receptacle Weight',
  type: 'stackedColumn',
  fields: [{
    name: 'PREDES with RESDES',
    color: '#7dbd7b',
  }, {
    name: 'PREDES without RESDES',
    color: '#ef696e',
  }],
  yTickFormat: amount => `${amount} kg`,
  xTickValues: data => formatLabels(data, 'hour'),
  composeChartData: data => composeBarChartData(
    data,
    ['predesWithResdesWeight', 'predesWithoutResdesWeight'],
    'hour',
    'kg',
  ),
};

const eventTargets = {
  title: 'Event Targets',
  type: 'stackedColumn',
  fields: [{
    name: '<= CST %',
    color: '#7dbd7b',
  }],
  yTickFormat: number => `${number} %`,
  xTickValues: data => formatLabels(data, 'hour'),
  composeChartData: data => composeBarChartData(
    data,
    ['onTimeCSTPercentage'],
    'hour',
    '%',
  ),
};

export default {
  eventTargets,
  receptacleCount,
  receptacleWeight,
};
